import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()
    window.Pusher = Pusher

    const token = useCookie('XSRF-TOKEN')

    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: config.public.REVERB_KEY,
        wsHost: config.public.REVERB_HOST,
        wsPort: Number(config.public.REVERB_PORT),
        wssPort: Number(config.public.REVERB_PORT),
        cluster: 'mt1',
        forceTLS: false,
        enabledTransports: ['ws', 'wss'],
        authEndpoint: '/api/broadcasting/auth',
        auth: {
            headers: {
                Authorization: `Bearer ${token.value}`,
            },
        },
    })
})
